import { TextField, Button, MenuItem, Box, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import {
  getAdmRegStudentDetails,
  getCountryCodeAndCountry,
  putAdmRegStudentDetails,
} from '../../../../redux/features/CRDslice';
import { Field, Form, Formik } from 'formik';
import dayjs from 'dayjs';
import { getClass, getMedium, getSyllabus } from '../../../../redux/features/deoSlice';
import MultipleSelectChip from './Components/MultipleSelectChip';
import StudentDetailsSection from './Components/StudentDetailsSection';
import ParentDetailsSection from './Components/ParentDetailsSection';
import GuardianDetailsSection from './Components/GuardianDetailsSection';
import SibilingsFamilyHomeDetailsSection from './Components/SibilingsFamilyHomeDetailsSection';
import { validationSchema } from './util/validationSchema';
import Loader3D from '../../../../components/Loader/Loader3D';
import { ASSESSMENT_REPORT_AMBITION, ASSESSMENT_REPORT_HOBBIES } from './util/GlobalDemo';
import AcademicLearningDetailsSection from './Components/AcademicLearningDetailsSection';
import SchoolDetailsSection from './Components/SchoolDetailsSection';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';

const StudentEditLanding = () => {
  const { id } = useParams();
  const { loading, countryCodeAndCountry, admRegStudentProfile } = useSelector((store) => store.crd);
  const [put, setPut] = useState(false);
  const handleApi = useHandleApiResponse();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAdmRegStudentDetails(id));
  }, [put]);

  const handleSubmit = (values) => {
    dispatch(putAdmRegStudentDetails({ id, data: values })).then((res) => {
      handleApi(res, {
        onSuccess: () => {
          setPut((prv) => !prv);
        },
      });
    });
  };

  const { loading: deoLoading, syllabuses, classes, medium } = useSelector((store) => store.deo);

  // -------------------- Json ----------------------

  //------------------------------------------------

  const initialValues = {
    studentName: admRegStudentProfile?.studentName ?? '',
    firstName: admRegStudentProfile?.firstName ?? '',
    lastName: admRegStudentProfile?.lastName ?? '',
    bloodGroup: admRegStudentProfile?.bloodGroup ?? '',
    fatherName: admRegStudentProfile?.fatherName ?? '',
    motherName: admRegStudentProfile?.motherName ?? '',
    fatherContactNumber: admRegStudentProfile?.fatherContactNumber ?? '',
    houseName: admRegStudentProfile?.houseName ?? '',
    landmark: admRegStudentProfile?.landmark ?? '',
    streetName: admRegStudentProfile?.streetName ?? '',
    post: admRegStudentProfile?.post ?? null,
    district: admRegStudentProfile?.district ?? '',
    contactNumber: admRegStudentProfile?.contactNumber ?? '',
    state: admRegStudentProfile?.state ?? '',
    pincode: admRegStudentProfile?.pincode ?? null,
    email: admRegStudentProfile?.email ?? '',
    schoolName: admRegStudentProfile?.schoolName ?? '',
    fatherCountryCode: admRegStudentProfile?.fatherCountryCode ?? null,
    studentCountryCode: admRegStudentProfile?.studentCountryCode ?? '',
    studentContactNumber: admRegStudentProfile?.studentContactNumber ?? '',
    currentClass: admRegStudentProfile?.currentClass ?? '',
    syllabus: admRegStudentProfile?.syllabus ?? '',
    medium: admRegStudentProfile?.medium ?? '',
    country: admRegStudentProfile?.country ?? '',
    cityTown: admRegStudentProfile?.cityTown ?? '',
    dateOfBirth: admRegStudentProfile?.dateOfBirth ?? '',
    admnNo: admRegStudentProfile?.admnNo ?? '', // not in fetch Data
    gender: admRegStudentProfile?.gender ?? '',

    // ---------------------------- New Fields -----------------------
    whatsappNumber: admRegStudentProfile?.whatsappNumber ?? '',
    guardian: admRegStudentProfile?.guardian ?? '',
    relationWithStudent: admRegStudentProfile?.relationWithStudent ?? '',
    schoolPlace: admRegStudentProfile?.schoolPlace ?? '',
    fatherOccupation: admRegStudentProfile?.fatherOccupation ?? '',
    fatherQualification: admRegStudentProfile?.fatherQualification ?? '',
    motherQualification: admRegStudentProfile?.motherQualification ?? '',
    motherOccupation: admRegStudentProfile?.motherOccupation ?? '',
    motherCountryCode: admRegStudentProfile?.motherCountryCode ?? null,
    motherMobileNumber: admRegStudentProfile?.motherMobileNumber ?? '', // not in fetch Data in motherMobileNumber chagne to Conata...
    fatherAnnualIncome: admRegStudentProfile?.fatherAnnualIncome ?? '',
    motherAnnualIncome: admRegStudentProfile?.motherAnnualIncome ?? '',
    studentHobbiesInterests: admRegStudentProfile?.studentHobbiesInterests ?? [],
    studentAmbition: admRegStudentProfile?.studentAmbition ?? '', // not in fetch
    trainerPreference: admRegStudentProfile?.trainerPreference ?? '', // not in fetch
    languageFluency: admRegStudentProfile?.languageFluency ?? [], // not int fetch
    siblings: admRegStudentProfile?.siblings ?? [{ name: '', age: '', class: '' }], // hasSibling ask how the data will be
    hasSiblings: admRegStudentProfile?.hasSiblings ?? 0,
    internetType: admRegStudentProfile?.internetType ?? '', //not in fetch
    homeType: admRegStudentProfile?.homeType ?? '',
    favouriteCartoonCharacter: admRegStudentProfile?.favouriteCartoonCharacter ?? '', // not fetch
    averageScreenTime: admRegStudentProfile?.averageScreenTime ?? '', //not fetch
    preferredTypeOfToy: admRegStudentProfile?.preferredTypeOfToy ?? '', // not fetch
    parentsAspirationChild: admRegStudentProfile?.parentsAspirationChild ?? '', // not fetch
    favouriteFood: admRegStudentProfile?.favouriteFood ?? '', // not fetch
    learningChallenges: admRegStudentProfile?.learningChallenges ?? '', // not fetch
    specialNeedsAndLearning: admRegStudentProfile?.specialNeedsAndLearning ?? '', // not fetch
    favouriteSubject: admRegStudentProfile?.favouriteSubject ?? '', // not fetch
    difficultSubject: admRegStudentProfile?.difficultSubject ?? '', // not fetch
    disabilities: admRegStudentProfile?.disabilities ?? '', // not fetch
  };
  useEffect(() => {
    dispatch(getCountryCodeAndCountry());
    dispatch(getSyllabus());
    dispatch(getClass());
    dispatch(getMedium());
  }, []);

  return (
    <GlobalWrapper title={'Student Edit'}>
      {loading ? (
        <Loader3D />
      ) : (
        <Box>
          <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                  }}
                >
                  {/* First Section*/}
                  <StudentDetailsSection
                    dayjs={dayjs}
                    values={values}
                    loading={loading}
                    countryCodeAndCountry={countryCodeAndCountry}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    classes={classes}
                    syllabuses={syllabuses}
                    medium={medium}
                  />

                  {/*second Sectionx*/}
                  <ParentDetailsSection
                    touched={touched}
                    errors={errors}
                    countryCodeAndCountry={countryCodeAndCountry}
                    loading={loading}
                    values={values}
                    setFieldValue={setFieldValue}
                  />

                  {/*Third Section*/}
                  <GuardianDetailsSection errors={errors} touched={touched} />

                  {/*Fourth Section*/}
                  <SibilingsFamilyHomeDetailsSection
                    values={values}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    errors={errors}
                    classes={classes}
                  />

                  {/*Fifth Section*/}

                  <AcademicLearningDetailsSection
                    errors={errors}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    values={values}
                  />

                  {/*Sixth Section*/}
                  <SchoolDetailsSection
                    countryCodeAndCountry={countryCodeAndCountry}
                    loading={loading}
                    errors={errors}
                    values={values}
                    touched={touched}
                    setFieldValue={setFieldValue}
                  />
                  <Paper elevation={3} sx={{ p: 4 }}>
                    <Typography variant="h4" mb={6}>
                      Hobbies & Interests
                    </Typography>
                    <Box display={'flex'} gap={2} flexDirection={'column'} maxWidth={900}>
                      <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
                        <MultipleSelectChip
                          lists={ASSESSMENT_REPORT_HOBBIES}
                          label={'Student Hobbies'}
                          initVal={values?.studentHobbiesInterests}
                          changeHandler={(v) => setFieldValue('studentHobbiesInterests', v)}
                          fullWidth
                          objKey={'name'}
                          obj={true}
                        />

                        <Field
                          as={TextField}
                          name="studentAmbition"
                          id={'studentAmbition'}
                          label={'Student Ambition'}
                          fullWidth
                          select
                          // sx={{ width: { sm: 350, xs: "100%" } }}
                        >
                          {ASSESSMENT_REPORT_AMBITION.map((e, i) => (
                            <MenuItem value={e?.name} ke={i}>
                              {e?.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </Box>
                      <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
                        <Field
                          as={TextField}
                          label="Challenges in Childs Learning"
                          name="learningChallenges"
                          fullWidth
                        />
                        <Field
                          as={TextField}
                          label="Special Needs and learning Disabilities"
                          name="specialNeedsAndLearning"
                          fullWidth
                        />
                      </Box>
                      <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
                        <Field as={TextField} label="Preffered type of toy" name="preferredTypeOfToy" fullWidth />
                        <Field as={TextField} label="Favourite Food" name="favouriteFood" fullWidth />
                      </Box>

                      <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
                        <Field as={TextField} label="Favourite Subject" name="favouriteSubject" fullWidth />
                        <Field as={TextField} label="Difficult Subject" name="difficultSubject" fullWidth />
                      </Box>

                      <Box display={'flex'} gap={2} flexDirection={{ xs: 'column', sm: 'row' }}>
                        <Field as={TextField} label="Disabilities" name="disabilities" fullWidth />
                        <Field
                          as={TextField}
                          label="Favourite Cartoon Character"
                          name="favouriteCartoonCharacter"
                          fullWidth
                        />
                      </Box>
                    </Box>
                  </Paper>
                  <Button
                    variant="contained"
                    sx={{
                      alignSelf: 'self-end',
                      px: 3,
                    }}
                    type="submit"
                  >
                    {loading ? 'Please Wait...' : 'Submit'}
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      )}
    </GlobalWrapper>
  );
};

export default StudentEditLanding;
